module.exports = __webpack_public_path__ + "img/status.518f2f6e.svg";